<div class="menu-mobile-container">
  <nav class="nav__main">
    <div class="sub-menu-mobile-header">
      <sbnb-icon icon="left-arrow" class="clickable nav-back-icon pr-2" (click)="back()"></sbnb-icon>
      <h3>{{ title }}</h3>
    </div>
    <sbnb-gx-subnav *ngIf="id === 'gx-mobile'"></sbnb-gx-subnav>
    <sbnb-operations-subnav *ngIf="id === 'ops-mobile'"></sbnb-operations-subnav>
    <sbnb-direct-subnav *ngIf="id === 'direct-mobile'"></sbnb-direct-subnav>
    <sbnb-settings-subnav *ngIf="id === 'settings-mobile'"></sbnb-settings-subnav>
    <sbnb-devices-subnav *ngIf="id === 'device-mobile'"></sbnb-devices-subnav>
  </nav>
</div>
